exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#charmes {\n  background-image: url(\"https://res.cloudinary.com/eclimontessori/image/upload/v1675852721/e7d6000396db35e96c4f325d251bf22d3a881d1c.original_gjet8x.jpg\"); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./app/pages/charmes/css/index.scss
// module id = 28
// module chunks = 8